<template>
  <div class="exr-item">
    <FileInput v-model="value.audio" accept="audio/*" placeholder="音频" tiny></FileInput>
  </div>
</template>

<script>
import FileInput from "@/components/FileInput.vue";

export default {
  name: "PdtItemAudio2",
  components: {FileInput},
  props: {
    value: Object,
  }
}
</script>